import FormInputMoney from '@components/forms/FormInputMoney';
import FormInputText from '@components/forms/FormInputText';
import ImageUpload from '@components/forms/FormImageUpload';
import { DialogTitle, DialogContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { TeamForm } from './CreateTeamUtils';
import { useFormContext } from 'react-hook-form';

export default function GeneralInfoStep() {
    const { watch } = useFormContext<TeamForm>();
    const [teamName] = watch('name');

    return (
        <>
            <DialogTitle>General Info</DialogTitle>
            <DialogContent>
                <Grid container spacing={4} padding={4} paddingTop={2} alignItems={'flex-end'}>
                    <Grid size={{ sm: 12, md: 6 }}>
                        <FormInputText name="name" label="Team Name" />
                    </Grid>
                    <Grid size={{ sm: 12, md: 6 }}>
                        <FormInputMoney label="Joining Fee" name="fee" />
                    </Grid>
                    {/* <Grid size={{ sm: 12 }}>
                        <FormInputText label="Team Description" name="description" />
                    </Grid> */}
                    <Grid size={{ sm: 12 }}>
                        <ImageUpload
                            description="Team Logo"
                            fieldName="imageUrl"
                            presetType={'team-image'}
                            fileDisplayName={`${teamName} Team Logo`}
                            uploadTags={teamName ? [teamName] : []}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </>
    );
}
